import ProjectViewFactory from "../factory"
import ProjectViews from "../project-views"
import {ViewType} from "../../../gd/const/views/view-type";
import ApiProject from "../../../gd/api/project";
import {ProjectViewConfig} from "../@types";

export default async function projectView_create(projectViews: ProjectViews, viewConfig:ProjectViewConfig) {

    let newView     = projectViews_createProjectViewFromConfig(projectViews, viewConfig)
    const project   = projectViews.project


    // Patch foe Expenses
    if (newView.systemType === ViewType.PROJECT_EXPENSES) {
        // auto enable Expenses when add first expenses view
        if (!project.properties.expenses) {
            project.properties.expenses = true
            await gd.api.Project.setProperties(project.id, project.properties.toJSON()).promise()

            gd.growl.success("Expenses are enabled for this project")
        }
    }
    //

    switch (newView.systemType) {

        // page requires special request for view creation
        // it subsequently creates document and connects it to the new view
        // project settings is also changed by this request so no save call is required
        case ViewType.PROJECT_TODOS:
        case ViewType.PROJECT_PAGE:
        case ViewType.PROJECT_WHITEBOARD:
        // dashboard requires to be created via endpoit as it could be created from template
        case ViewType.PROJECT_DASHBOARD:
            const result    = await ApiProject.addView(newView).promise()

            // recreate model based on reply
            newView         = ProjectViewFactory(result.view, projectViews)

            // the server already added it to settings.views, but the collection only catches
            // up when the settings delta lands - until then any save() would write it out again
            if (!projectViews.get(newView.id)) {
                projectViews.add(newView)
                projectViews.sort()
            }

            return newView

        // adds view to views and save project settings with new view added
        default:
            projectViews.add(newView)
            projectViews.sort()
            await projectViews.save()
    }

    return newView
}

export function projectViews_createProjectViewFromConfig(projectViews: ProjectViews, viewConfig: ProjectViewConfig) {
    viewConfig.id       = viewConfig.id || projectViews.getNewId()
    viewConfig.userId   = gd.user.id // set owner (!)

    return ProjectViewFactory(viewConfig, projectViews)
}
